import React, { useEffect, useRef } from "react";
import data from "../../../data/Presentation.json";
import PresentationElement from "./PresentationElement";
import s from "./Presentation.module.css";

const Presentation = () => {
  const containerRef = useRef(null);
  const isAutoScrollingRef = useRef(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return undefined;
    }

    const handleWheel = (event) => {
      if (window.innerWidth <= 768 || isAutoScrollingRef.current) {
        return;
      }

      const absDelta = Math.abs(event.deltaY);
      if (absDelta < 10) {
        return;
      }

      const sections = Array.from(
        container.querySelectorAll("[data-snap-section='true']")
      );
      if (!sections.length) {
        return;
      }

      const currentIndex = sections.reduce((bestIndex, section, index) => {
        const rect = section.getBoundingClientRect();
        const distance = Math.abs(rect.top - 60);
        if (distance < bestIndex.distance) {
          return { index, distance };
        }
        return bestIndex;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;

      const direction = event.deltaY > 0 ? 1 : -1;
      const nextIndex = Math.min(
        sections.length - 1,
        Math.max(0, currentIndex + direction)
      );

      if (nextIndex === currentIndex) {
        return;
      }

      event.preventDefault();
      isAutoScrollingRef.current = true;
      const targetRect = sections[nextIndex].getBoundingClientRect();
      const targetTop = window.scrollY + targetRect.top - 60;
      window.scrollTo({ top: targetTop, behavior: "smooth" });
      window.setTimeout(() => {
        isAutoScrollingRef.current = false;
      }, 1100);
    };

    container.addEventListener("wheel", handleWheel, { passive: false });
    return () => container.removeEventListener("wheel", handleWheel);
  }, []);

  const heroBackground = `${process.env.PUBLIC_URL}/images/gallery/lksm.jpg`;
  const cards = data.elements.map((item, index) => (
    <PresentationElement
      key={`${item.name}-${index}`}
      name={item.name}
      img={item.img}
      text={item.text}
    />
  ));

  return (
    <div ref={containerRef} className={s.container}>
      <div
        className={s.valueSection}
        data-snap-section="true"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.76)), url('${heroBackground}')`,
        }}
      >
        <div className={s.heroOverlay}>
          <p className={s.title}>{data.title}</p>
          <p className={s.valueOfPioneering}>{data.valueOfPioneering}</p>
        </div>
      </div>
      <div className={s.cardsGrid}>{cards}</div>
    </div>
  );
};
export default Presentation;
